import { Json } from "@/lib/supabase/supabaseTypesImport";
import { getReminderStageLabel } from "@/lib/utils/reminder-stage-label";
import { FIRST_FEE_STAGE } from "./reminder-stage";

export interface ReminderScheduleSettings {
	days_payment: number | null;
	days_payment_reminder: number | null;
	days_payment_mahnung_1: number | null;
	days_payment_mahnung_2: number | null;
	mahnung_max_count: number | null;
	reminder_fee_amounts: Json | null;
}

export interface ReminderTimelineStage {
	stage: number;
	label: string;
	day: number;
	fee: number;
	totalFees: number;
}

export function getReminderStageFee(
	feeAmounts: Json | null,
	stage: number
): number {
	if (
		stage < FIRST_FEE_STAGE ||
		!feeAmounts ||
		typeof feeAmounts !== "object" ||
		Array.isArray(feeAmounts)
	) {
		return 0;
	}
	const fee = feeAmounts[`stage_${stage}`];
	return typeof fee === "number" ? fee : 0;
}

function getWaitingDays(settings: ReminderScheduleSettings, stage: number) {
	if (stage === 1) return settings.days_payment_reminder ?? 0;
	if (stage === 2) return settings.days_payment_mahnung_1 ?? 0;
	return settings.days_payment_mahnung_2 ?? 0;
}

// Mirrors the cadence of payment_reminder_candidates for a regular invoice.
export function buildReminderTimeline(settings: ReminderScheduleSettings) {
	const dueDay = settings.days_payment ?? 0;
	const stages: ReminderTimelineStage[] = [];
	let day = dueDay;
	let totalFees = 0;

	for (let stage = 1; stage <= (settings.mahnung_max_count ?? 0); stage++) {
		day += getWaitingDays(settings, stage);
		const fee = getReminderStageFee(settings.reminder_fee_amounts, stage);
		totalFees += fee;
		stages.push({
			stage,
			label: getReminderStageLabel(stage),
			day,
			fee,
			totalFees,
		});
	}

	return { dueDay, stages };
}
